import { UserProps } from "@store/slices/userSlice";

export function getConfig(user: UserProps) {
    return {
        headers: { Authorization: `Bearer ${user.token}`, filterAll: user.filterAll },
    };
}